<template>
  <div class="theme-switcher" :class="{ 'collapsed': isCollapsed }">
    <button @click="$emit('toggle-theme')" class="theme-toggle-btn">
      <svg v-if="currentTheme === 'dark'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="5"></circle>
        <line x1="12" y1="1" x2="12" y2="3"></line>
        <line x1="12" y1="21" x2="12" y2="23"></line>
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
        <line x1="1" y1="12" x2="3" y2="12"></line>
        <line x1="21" y1="12" x2="23" y2="12"></line>
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
      </svg>
      <span v-if="!isCollapsed">{{ currentTheme === 'dark' ? 'Light Mode' : 'Dark Mode' }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ThemeSwitcher',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    currentTheme: {
      type: String,
      default: 'dark'
    }
  },
  emits: ['toggle-theme']
}
</script>

<style scoped>
.theme-switcher {
  margin-bottom: 1.5rem;
}

.theme-switcher.collapsed {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.theme-toggle-btn {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.theme-switcher.collapsed .theme-toggle-btn {
  width: auto;
  padding: 0.5rem;
  justify-content: center;
}

.theme-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.theme-toggle-btn svg {
  width: 18px;
  height: 18px;
  margin-right: 0.75rem;
}

.theme-switcher.collapsed .theme-toggle-btn svg {
  margin-right: 0;
}

:root[data-theme="light"] .theme-toggle-btn {
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.8);
}

:root[data-theme="light"] .theme-toggle-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}
</style> 